import { z } from "zod";

/**
 * Boundary validation for the Microsoft GDAP automation workflow. The API is
 * authoritative. No Microsoft token, authorization code, or client secret is
 * validated here — those never appear in web-facing or agent request bodies.
 */

/** POST /api/v1/browser-sessions/:id/gdap (web → API). Empty body. */
export const startGdapSchema = z.object({}).strict().default({});

export type StartGdapInput = z.infer<typeof startGdapSchema>;

const agentIdentitySchema = z.object({
  agentVersion: z.string().trim().min(1).max(50),
  workstationId: z.string().trim().min(1).max(200),
});

/**
 * POST /agent/navigate — the agent acknowledges it opened a navigate directive
 * (e.g. the GDAP customer-approval page) so the API stops re-issuing it.
 */
export const agentNavigateAckSchema = agentIdentitySchema.extend({
  navigateId: z.string().trim().min(1).max(200),
});

export type AgentNavigateAckInput = z.infer<typeof agentNavigateAckSchema>;

/**
 * POST /agent/tenant — the agent reports the customer tenant id it detected via
 * a silent identity OAuth in the isolated session, so the API binds the session
 * tenant and lets the GDAP workflow proceed.
 */
export const agentTenantReportSchema = agentIdentitySchema.extend({
  detectId: z.string().trim().min(1).max(200),
  tenantId: z.string().trim().min(1).max(100),
});

export type AgentTenantReportInput = z.infer<typeof agentTenantReportSchema>;
